<template>
  <div class="account-detail-component" v-if="selectedAccount">
    <header></header>
    <div class="p-3">
      <div class="is-flex is-justify-content-space-between">
        <h3>{{ selectedAccount?.name }}</h3>
        <span @click="$emit('close')">
          <font-awesome-icon :icon="['far', 'times-circle']" size="2x"></font-awesome-icon>
        </span>
      </div>
      <div>
        <span class="subtitle has-text-grey" v-if="$hasRole('Super User,Kymeta Admin,Sales Support')">({{selectedAccount.id}})</span>
        <hr>
        <detail-field v-if="selectedAccount" label-width="175">
          <template v-slot:label>Parent Account</template>
          <template v-slot:value>{{selectedAccount.parent?.name || '-'}}</template>
        </detail-field>
        <detail-field v-if="selectedAccount" label-width="175">
          <template v-slot:label>Primary Contact</template>
          <template v-slot:value>
            <a :href="`mailto:${selectedAccount.primaryContact?.email}`" v-if="selectedAccount.primaryContact?.email">{{selectedAccount.primaryContact?.name || 'Unknown'}}</a>
            <span v-else>-</span>
          </template>
        </detail-field>
        <template v-if="$hasRole('Super User,Kymeta Admin,Sales Support')">
          <detail-field label-width="175">
            <template v-slot:label>Oracle ID</template>
            <template v-slot:value>{{selectedAccount.oracleAccountId || '-'}}</template>
          </detail-field>
          <detail-field label-width="175">
            <template v-slot:label>Salesforce ID</template>
            <template v-slot:value>{{selectedAccount.salesforceAccountId || '-'}}</template>
          </detail-field>
          <detail-field label-width="175">
            <template v-slot:label>Type of Company</template>
            <template v-slot:value>{{selectedAccount.relationshipType || '-'}}</template>
          </detail-field>
          <template v-if="selectedAccount?.configurator?.configuratorVisible">
            <detail-field label-width="175">
              <template v-slot:label>Military Price Book</template>
              <template v-slot:value>{{selectedAccount.configurator.militaryPriceBook ? 'Yes' : 'No'}}</template>
            </detail-field>
            <detail-field label-width="175">
              <template v-slot:label>Commercial Price Book</template>
              <template v-slot:value>{{selectedAccount.configurator.commercialPriceBook ? 'Yes' : 'No'}}</template>
            </detail-field>
            <detail-field label-width="175">
              <template v-slot:label>Can see Wholesale</template>
              <template v-slot:value>{{selectedAccount.configurator.wholesalePricesVisible ? 'Yes' : 'No'}}</template>
            </detail-field>
            <detail-field label-width="175">
              <template v-slot:label>Can see MSRP</template>
              <template v-slot:value>{{selectedAccount.configurator.msrpPricesVisible ? 'Yes' : 'No'}}</template>
            </detail-field>
            <detail-field label-width="175">
              <template v-slot:label>Discount Tier</template>
              <template v-slot:value>{{selectedAccount.configurator.discountTier || '-'}}</template>
            </detail-field>
          </template>
          <template v-else>
            <p class="mt-4 is-italic">Configurator not available. Please contact your Kymeta Sales Representative.</p>
          </template>
        </template>
        <hr v-if="selectedAccount && (sharedAccounts.length > 0)"> 
        <h5 v-if="selectedAccount && (sharedAccounts.length > 0)">SHARING</h5>
        <div v-if="selectedAccount && (sharedAccounts.length > 0)" class="column column-left-padding-0" >
          <p>The following Accounts have shared artifacts (Remotes, Subscriptions or Devices) with '<strong>{{selectedAccount.name}}</strong>':</p>
        </div>
        <b-table 
          :data="sharedAccounts" 
          :scrollable="false"
          bordered
          v-if="selectedAccount && (sharedAccounts.length > 0)">
          <b-table-column label="Account" v-slot="props" width='200px'>
            {{ props.row.name }}
          </b-table-column>
        </b-table>
      </div>
    </div>
  </div>
</template>
<script>
import { format } from 'date-fns';
// import RestrictedWrapper from '../../shared/RestrictedWrapperComponent.vue';

export default {
  props: ['selectedAccount', 'sharedAccounts'],
  components: {
    // RestrictedWrapper
  },
  computed: {
    origin() {
      const origin = this.selectedAccount.origin ? this.selectedAccount.origin : 'API';
      // changing nested ternary to switch
      switch (origin) {
        case 'SF': return 'SalesForce';
        case 'OSS': return 'Portal';
        default: return 'API';
      }
    }
  },
  data() {
    return {
      format
    };
  },
  watch: {
    // eslint-disable-next-line
    selectedAccount: async function () {
      this.$forceUpdate();
    },
  }
};
</script>
<style lang="scss" scoped>
@import "../../styles/colors";

.account-detail-component {
  min-width: 640px;
  max-width: 800px;
  background: white;

  header {
    background: $blue;
    height: 0.25rem;
  }

  .user-section-divider {
    margin: 1rem 45%;
    border-bottom: 4px solid $blue;
    display: block;
    height: 4px;
  }

  .close-user-detail {
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;
  }
}
</style>
